import React, { useContext } from "react";

import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";
import {
	BrWidgetOtherConfig,
	ExeFeedWidgetOtherConfig,
	LsOtherConfig,
} from "@features/live-widgets/shared";
import { EventContext, SportOfferContext } from "@gp/components";
import { ProviderNameEnum } from "@gp/models";
import { useLiveWidgetStore } from "@state/hooks/live-widgets";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import classNames from "classnames";
import { observer } from "mobx-react";

export default observer(function SimulationButton({
	store,
}: {
	store: EventViewStore;
}) {
	const event = useContext(EventContext);
	const sport = useContext(SportOfferContext);

	const teamOneName =
		store.lookupsStore.teams.get(event.teamOneId || "")?.name || "";
	const teamTwoName =
		store.lookupsStore.teams.get(event.teamTwoId || "")?.name || "";

	const { toggleLmtWidget, findActiveLmtWidget } = useLiveWidgetStore();

	const isActive = findActiveLmtWidget(event.id, WidgetLocation.EVENT_OFFER);

	const isDisabled = (function () {
		if (event.isOutright || !event.source?.matchId) {
			return true;
		}
		if (event.source.providerName == ProviderNameEnum.LSports) {
			return (
				!WEBPACK_IS_LS_WIDGET_ENABLED ||
				!LsOtherConfig.supportedSports.includes(sport?.abrv)
			);
		}
		if (event.source.providerName == ProviderNameEnum.BetRadar) {
			return !BrWidgetOtherConfig.supportSports.includes(sport?.abrv);
		}
		if (event.source.providerName == ProviderNameEnum.ExeFeed) {
			return !ExeFeedWidgetOtherConfig.supportSports.includes(
				sport?.abrv
			);
		}

		return true;
	})();

	const buttonClasses = classNames(
		"at-actionStatsWidget event__top__btn btn btn--square btn--square--sml btn--ghost btn--icon",
		{
			"is-disabled": isDisabled,
		}
	);

	const iconClasses = classNames("u-icon u-icon--sml", {
		[`u-icon--field--soccer--active u-icon--field--${sport?.abrv}--active`]:
			!isActive && !isDisabled,
		[`u-icon--field--soccer--selected u-icon--field--${sport?.abrv}--selected u-color--core--snow`]:
			isActive && !isDisabled,
		[`u-icon--field--soccer--disabled u-icon--field--${sport?.abrv}--disabled`]:
			isDisabled,
	});

	return (
		<button
			className={buttonClasses}
			type="button"
			onClick={() => {
				if (!event.source?.matchId) {
					return;
				}
				toggleLmtWidget({
					sport: sport.abrv,
					provider: event.source!.providerName,
					matchId: event.source?.matchId,
					eventId: event.id,
					teamOneName: teamOneName,
					teamTwoName: teamTwoName,
					location: WidgetLocation.EVENT_OFFER,
				});
			}}
			disabled={isDisabled}
		>
			<i className={iconClasses} />
		</button>
	);
});
